// Single source of truth for every lender the site links to. Add a lender = add one entry; every financing button reads
// from here. Never alter Acorn's `d=1LJ9P` — it credits applications to us. Links open in a new tab, rel="noopener sponsored",
// link out only (never iframe/embed a lender page).
export const LENDERS = [
  {
    id: "acorn",
    name: "Acorn Finance",
    url: "https://www.acornfinance.com/pre-qualify/?d=1LJ9P&utm_medium=web_pre_qual_link_copy_welcome",
    host: "www.acornfinance.com",
    buttonLabel: "Pre-qualify with Acorn",
    amountRange: "$1,000–$100,000",
    pitch: "Compare offers from 20+ lenders in about two minutes.",
    min: 1000,
    max: 100000,
    amountParam: "loanAmount",
  },
  {
    id: "hfs",
    name: "HFS Financial",
    url: "https://www.hfsfinancial.net/promo/6ac5a40dd7c5e0a83ca7b531",
    host: "www.hfsfinancial.net",
    buttonLabel: "Check rates with HFS",
    amountRange: "Up to $450,000",
    pitch: "Personal loans for larger projects — no home equity or appraisal required, terms up to 30 years.",
    min: 1000,
    max: 450000,
    amountParam: null,
  },
];

export const LENDER_REL = "noopener sponsored";
export const lender = (id) => LENDERS.find((l) => l.id === id);
export const ACORN = lender("acorn");
export const HFS = lender("hfs");

// Pre-qual link, optionally pre-filled with a whole-dollar loan amount (only lenders that accept one).
export const lenderUrl = (id, loanAmount) => {
  const l = lender(id);
  const n = Math.round(Number(loanAmount));
  return l.amountParam && Number.isFinite(n) && n > 0 ? `${l.url}&${l.amountParam}=${n}` : l.url;
};

// Lenders whose range covers the amount (no amount → all).
export const lendersFor = (amount) => {
  const n = Math.round(Number(amount));
  return Number.isFinite(n) && n > 0 ? LENDERS.filter((l) => n <= l.max) : LENDERS;
};
